import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../core/shared/basic/object-identifier-data";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";

@Component({
    selector: 'ea-project-list-widget',
    templateUrl: './ea-project-list-widget.component.html',
    standalone: false
})
export class EaProjectListWidgetComponent implements OnInit, OnChanges, OnDestroy {

    @Input() filters: FilterCriteria[] = [];
    @Output() onProjectSelect: EventEmitter<ObjectIdentifierData> = new EventEmitter<ObjectIdentifierData>();

    busy: boolean;
    initialized: boolean;
    projectWidgetData: WidgetData;

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent() {
        this.refreshComponent();
    }

    refreshComponent() {
        this.projectWidgetData = WidgetFactory.createWidgetTableEntityQl(
            'ea.project.list.widget',
            'EA Projects',
            'ea.EaProject',
            'No projects found',
            this.filters,
            [],
            true
        );
        this.initialized = true;
    }

    handleProjectSelect(event: ObjectIdentifier | ObjectIdentifierData) {
        this.onProjectSelect.emit({objectType: event.objectType, objectId: event.objectId} as ObjectIdentifierData);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes["filters"]) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
